import useGetStats from './useGetStats';
import {LoadingText} from 'components/Loading';
import {getFormattedNumber} from 'utils/numbers';
import styles from './HeroStats.module.scss';
import {Link} from 'react-router-dom/cjs/react-router-dom.min';

const STATS = [
  {
    key: 'certs',
    label: 'Certifications',
    link: 'search/certified-entities',
  },
  {
    key: 'cbs',
    label: 'Certification Bodies',
    link: 'search/certification-bodies',
  },
  {
    key: 'abs',
    label: 'Accreditation Bodies',
    link: 'search/accreditation-bodies',
  },
];

function TextLink({to, text, isLoading}) {
  if (isLoading) return <LoadingText isLoading />;
  if (!to) return text;

  return <Link to={to}>{text}</Link>;
}

function HeroStats() {
  const {isLoading, stats} = useGetStats();
  return (
    <div className={styles['hero-stats']}>
      {STATS.map((item, index) => {
        const {key, label, link} = item;

        return (
          <div className={styles['hero-stats--content']} key={index}>
            <TextLink
              to={link}
              text={<p>{getFormattedNumber(stats[key], '0,0', false)}</p>}
              isLoading={isLoading}
            />
            <TextLink text={<h5>{label}</h5>} to={link} />
          </div>
        );
      })}
    </div>
  );
}

export default HeroStats;
